import { Avatar, Card, CardHeader, IconButton, Tooltip, Typography } from "@mui/material"
import { RemoveRedEye, Delete } from '@mui/icons-material'
import { makeStyles } from "@mui/styles";
import { ReactNode } from "react";

interface ShowTooltipProps {
  preview?: boolean;
  delete?: boolean;
  filename?: boolean;
  description?: boolean;
}

interface TooltipTitleProps {
  preview?: NonNullable<ReactNode>;
  delete?: NonNullable<ReactNode>;
}

interface FileData {
  filename: string;
  description: string;
  url: string;
}

interface UploadInformationsCardProps {
  id: string;
  data: FileData;
  hideDeleteButton?: boolean
  onDelete?: (id: string) => void
  onPreview: (url: string) => void
  showTooltip?: ShowTooltipProps
  tooltipTitle?: TooltipTitleProps
}

const DELETE_TOOLTIP_DEFAULT_TITLE = "Remover"
const PREVIEW_TOOLTIP_DEFAULT_TITLE = "Visualizar"

const useStyles = makeStyles(() => ({
  deleteButton: {
    cursor: 'pointer'
  },
  avatar: {
    background: 'rgba(1, 114, 38, 0.1)',
    cursor: 'pointer'
  },
  root: {
    border: '1px solid #017226'
  },
  cardHeaderContainer: {
    alignItems: 'center'
  },
  action: {
    alignSelf: 'flex-end'
  },
}))

const UploadInformationsCard = (props: UploadInformationsCardProps) => {
  const {
    data: { filename, description, url },
    onDelete,
    onPreview,
    id,
    hideDeleteButton = false,
    tooltipTitle = { delete: DELETE_TOOLTIP_DEFAULT_TITLE, preview: PREVIEW_TOOLTIP_DEFAULT_TITLE },
    showTooltip = { delete: true, preview: true, description: true, filename: true }
  } = props;

  const classes = useStyles(props)
  
  return (
    <Card classes={classes}>
      <CardHeader
        className={classes.cardHeaderContainer}
        classes={{ action: classes.action }}
        avatar={
          <Tooltip title={showTooltip.preview ? (tooltipTitle.preview || PREVIEW_TOOLTIP_DEFAULT_TITLE) : ''}>
            <Avatar className={classes.avatar} onClick={() => onPreview(url)}>
              <RemoveRedEye htmlColor={"#017226"} />
            </Avatar>
          </Tooltip>
        }
        title={
          <>
            <Typography align="left" variant="body1" color="textPrimary" noWrap={true} className="texto-anexo">
              <Tooltip title={showTooltip.filename ? filename : ''}>
                <span>
                  {filename}
                </span>
              </Tooltip>
            </Typography>
            <Typography align="left" variant="body2" color="textSecondary" noWrap={true} className="texto-anexo">
              <Tooltip title={showTooltip.description ? description : ''}>
                <span>
                  {description}
                </span>
              </Tooltip>
            </Typography>
          </>
        }
        action={
          <>
            {!hideDeleteButton && (
              <Tooltip title={showTooltip.delete ? (tooltipTitle.delete || DELETE_TOOLTIP_DEFAULT_TITLE) : ''}>
                <IconButton onClick={onDelete ? () => onDelete(id) : undefined} size="large">
                  <Delete color="error" fontSize={"medium"} />
                </IconButton>
              </Tooltip>
            )}
          </>
        }>
      </CardHeader>
    </Card>
  );

}

export { UploadInformationsCard }